// removed by extract-text-webpack-plugin
module.exports = {"expandButton":"expand-button-module__expandButton___u0ZT-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/expand-button/expand-button.module.scss
// module id = 267
// module chunks = 0